export const FIELDS_TEST_ID = {
  firstName: 'first-name',
  lastName: 'last-name',
  businessName: 'business-name',
  emailAddress: 'email-address',
  phoneNumber: 'phone-number',
  zipCode: 'zip-code',
};
